import { useEffect } from 'react';

export function useHorizontalOverflowHidden(enabled: boolean) {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    document.body.style.overflowX = 'hidden';
    return () => {
      document.body.style.overflowX = '';
    };
  });
}
